module.exports = __webpack_public_path__ + "img/logo-hsc.4506c5ec.svg";